import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';

const BACKGROUND_COLOR_OPACITY_MIN = 0;
const BACKGROUND_COLOR_OPACITY_DISPLAY_MIN = 0;
const BACKGROUND_COLOR_OPACITY_MAX = 1;
const BACKGROUND_COLOR_OPACITY_DISPLAY_MAX = 100;

interface BackgroundColorOpacityOptionProps {
  fillObject: FillObject;
  updateOpacity(fillAlpha: number, undoable?: boolean): void;
}

export function BackgroundColorOpacityOption({...props}: BackgroundColorOpacityOptionProps): ReactElement | null {
  if (props.fillObject.fillType === FillTypes.NONE) {
    return null;
  }

  const getColorOpacityOption = (): ReactElement => {
    return (
      <ContextualMenuSliderOptions
        id="background-color-opacity-option"
        className="spacing-m-b-4"
        value={props.fillObject.fillColor[0][3]}
        label={window.i18next.t('pmwjs_opacity')}
        range={{
          min: BACKGROUND_COLOR_OPACITY_MIN,
          max: BACKGROUND_COLOR_OPACITY_MAX,
        }}
        transformDisplay={{
          min: BACKGROUND_COLOR_OPACITY_DISPLAY_MIN,
          max: BACKGROUND_COLOR_OPACITY_DISPLAY_MAX,
        }}
        onChange={(updatedValue: number): void => {
          props.updateOpacity(updatedValue, false);
        }}
        onChangeEnded={(updatedValue: number): void => {
          props.updateOpacity(updatedValue);
        }}
      />
    );
  };

  return getColorOpacityOption();
}
